import React, { useEffect, useRef } from 'react'
import { Col, Container } from 'react-bootstrap'
import Slider from 'react-slick'
import { GatsbyImage } from 'gatsby-plugin-image'
import ArrowLeftIcon from '../../../icons/arrow-left'
import ArrowRightIcon from '../../../icons/arrow-right'

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <ArrowRightIcon
      className={className}
      style={{ ...style, height: '52px', width: '24px', right: '-45px' }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <ArrowLeftIcon
      className={className}
      style={{ ...style, height: '52px', width: '24px', left: '-45px' }}
      onClick={onClick}
    />
  )
}

const ProductImageCarousel = ({ images, variant }) => {
  // function to determine if it's first render
  function useFirstRender() {
    const firstRender = useRef(true)

    useEffect(() => {
      firstRender.current = false
    }, [])

    return firstRender.current
  }

  // initial set of the reference
  const sliderRef = useRef(null)

  // variant: variant selected
  // variantSelector: color of variant selected
  const variantSelector =
    variant.selectedOptions && variant.selectedOptions[0].value

  const firstRender = useFirstRender()

  useEffect(() => {
    // if first render, set slider to 0.
    if (firstRender) {
      return sliderRef.current.slickGoTo(0)
    }

    // Checks images altText(which is color) and if equal to color selected, go to that index.
    // Updated on color change.
    let flag = false

    images.some((v, index) => {
      if (sliderRef.current !== null) {
        const colorPattern = new RegExp(
          `${variantSelector.toLowerCase()} \\d+`,
          'i',
        )
        if (v.altText.toLowerCase().match(colorPattern)) {
          sliderRef.current.slickGoTo(index)
          flag = true
        }
        // if (v.altText.includes(variantSelector)) {
        //   return
        // }
      }
    })

    if (!flag) {
      images.some((v, index) => {
        if (sliderRef.current !== null) {
          if (v.altText.includes(variantSelector)) {
            sliderRef.current.slickGoTo(index)
          }
        }
      })
    }
  }, [firstRender, variantSelector])

  console.log(images, variantSelector)

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <Container>
      <Slider {...settings} ref={sliderRef}>
        {images.map((img, index) => {
          return (
            <GatsbyImage
              loading='eager'
              key={index}
              image={img.gatsbyImageData}
              alt='Product Image'
              className=''
              width={550}
              height={550}
            />
          )
        })}
      </Slider>
    </Container>
  )
}

export default ProductImageCarousel
